<script>
import { required } from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify';
import CoordinateMapModal from './coordinate_map_modal.vue';

export default {
  name: 'CreateGroupModal',
  components: { CoordinateMapModal },
  props: ["list"],
  data() {
    return {
      form: {},
      ilList: [],
      submitted: false,
      loading: false,
      mapOpen: 0,
    };
  },
  validations: {
    form: {
      name: { required },
    },
  },
  watch: {
    list(props) {
      this.form = {
        ...props,
        block: props.block || props.ip_block || '',
      };
    },
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return;
      }

      if (this.form.id) this.update();
      else this.create();

      this.$emit('loadItems');
      this.submitted = false;
    },
    create() {
      this.$http.post('/transmitter/groups/store', this.form)
        .then(resp => {
          this.form = {};
          this.loading = false;
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    update() {
      this.$http.put('/transmitter/groups/' + this.form.id, this.form)
        .then(resp => {
          this.loading = false;
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    remove(id) {
      this.$http.delete('/transmitter/groups/' + id)
        .then(resp => {
          this.loading = false;
          if (resp.data.code !== 100) return notify.error(resp.data.message);
          return notify.success(resp.data.message);
        })
        .catch(() => { this.loading = false; });
    },
    openMap() {
      this.mapOpen = Date.now();
    },
    onCoordinateConfirm(coord) {
      this.form = { ...this.form, coordinate: coord || null };
    },
    close() {
      this.$parent.$bvModal.hide('group-modal-scoped');
    },
  },
};
</script>

<template>
  <div>
    <CoordinateMapModal
      modal-id="pop_coordinate_map_modal"
      title="POP Konumu Seç"
      :open="mapOpen"
      :value="form.coordinate || ''"
      @confirm="onCoordinateConfirm"
    />

    <b-modal id="group-modal-scoped" title="POP Noktası Ekle" no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Verici İsmi</label>
          <div class="col">
            <input
              id="name"
              v-model="form.name"
              type="text"
              class="form-control"
              placeholder="Verici İsmi"
              :class="{ 'is-invalid': submitted && $v.form.name.$error }"
            />
            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">
              Bu alanı doldurmak zorunludur.
            </div>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Adres</label>
          <div class="col">
            <input id="address" v-model="form.address" type="text" class="form-control" placeholder="Adres" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Koordinat</label>
          <div class="col">
            <div class="input-group">
              <input
                id="coordinate"
                v-model="form.coordinate"
                type="text"
                class="form-control"
                placeholder="Haritadan seçin"
                readonly
              />
              <button class="btn btn-outline-primary" type="button" @click="openMap">
                Haritadan Seç
              </button>
            </div>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">İp Bloğu</label>
          <div class="col">
            <input id="block" v-model="form.block" type="text" class="form-control" placeholder="İp Bloğu" />
          </div>
        </div>

        <div class="row d-flex mb-1">
          <label class="col-sm-3 col-form-label">Açıklama</label>
          <div class="col">
            <input id="explaine" v-model="form.explaine" type="text" class="form-control" placeholder="Açıklama" />
          </div>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <div>
            <b-button variant="danger" v-if="form.id" @click="remove(form.id)">Sil</b-button>
          </div>
          <div>
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button v-if="form.id" type="submit" variant="warning" class="ms-1">Güncelle</b-button>
            <b-button v-else type="submit" variant="success" class="ms-1" :disabled="loading">
              <span v-if="loading">
                <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              </span>
              Oluştur
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
